<template>
    <div class="column is-narrow-desktop is-one-third-touch is-centered is-flex is-horizontal-center">
        <figure class="image is-128x128 has-text-centered" @click="addClickedModelToQuery(model)">
            <img :src="model.img" />
            <input v-model="isActive" type="checkbox" />
            <span class="is-size-7">{{ model.name }}</span>
        </figure>
    </div>
</template>

<script>
    export default {
        props: ['model'],
        methods: {
            addClickedModelToQuery: function (model) {
                if (this.$store.getters.getQueryModelsByModel(model.name).length === 0) {
                    this.$store.dispatch('addModelToQuery', model.name)
                } else {
                    this.$store.dispatch('removeModelFromQuery', model.name)
                }
            }
        },
        computed: {
            isActive: {
                get: function () {
                    return this.$store.getters.getQueryModelsByModel(this.model.name).length !== 0
                },
                set: (value) => {

                }
            }
        }
    }
</script>

<style scoped>
    .is-horizontal-center {
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Model/AuctionModelImage.vue